import React from 'react';
import styled from 'styled-components';

export default function DateColumnHeader({date, label, labelTxt}) {
	return (
		<StyledDateColumnHeader className="StyledDateColumnHeader">
			{label && <section className="HeaderLabelText">{label}</section>}
			{date && <section className="HeaderDateText">{date}</section>}
			{labelTxt && <section className="HeaderLabelText">{labelTxt}</section>}
		</StyledDateColumnHeader>
	);
}

const StyledDateColumnHeader = styled.section`
	display: flex;
	flex-direction: column;
	align-items: flex-end;
	justify-content: flex-end;
	color: var(--neutrals-900);
	font-size: var(--px-12);
	font-weight: 400;
	line-height: var(--px-16);
	.HeaderLabelText,
	.HeaderDateText {
		display: flex;
		min-height: var(--px-16);
	}
`;
